/* eslint-disable */
import React, { useRef, useEffect, useState } from "react";
import { Map, TileLayer, LayersControl } from "react-leaflet";
import L from "leaflet";
import RodFooter from "./RodFooter";

L.NumberedDivIcon = L.Icon.extend({
  options: {
    // EDIT THIS TO POINT TO THE FILE AT http://www.charliecroom.com/marker_hole.png (or your own marker)
    iconUrl: "",
    iconSize: new L.Point(35, 35),
  },

  createIcon: function () {
    var div = document.createElement("div");
    var img = this._createImg(this.options["iconUrl"]);
    var numdiv = document.createElement("div");
    numdiv.setAttribute("class", "leaflet-custom-number");
    numdiv.innerHTML = this.options["number"] || "";
    div.appendChild(img);
    div.appendChild(numdiv);
    this._setIconStyles(div, "icon");
    return div;
  },

  //you could change this to add a shadow like in the normal marker if you really wanted
  createShadow: function () {
    return null;
  },
});

const Mapa = ({ data, isHotspot, setisHotspot }) => {
  const mapRef = useRef();
  const [bounds, setbounds] = useState([
    [-90, -180],
    [90, 180],
  ]);
  useEffect(() => {
    const { current = {} } = mapRef;
    const { leafletElement: map } = current;
    var groupLayer = new L.FeatureGroup();
    data.map((o, i) => {
      L.marker(o.coords, { icon: new L.NumberedDivIcon({ number: i + 1 }) })
        .bindTooltip(o.name)
        .on("click", function (e) {
          setisHotspot(o);
        })
        .addTo(groupLayer);
    });
    groupLayer.addTo(map);
    // setbounds(groupLayer.getBounds());
    map.fitBounds(groupLayer.getBounds());
  }, []);

  useEffect(() => {
    if (isHotspot === null) return;

    mapRef.current.leafletElement.flyTo(
      [isHotspot.coords[0] + 0.005, isHotspot.coords[1] - 0.0003],
      16,
      {
        duration: 2,
      }
    );
  }, [isHotspot]);

  const iconClick = () => {
    setisHotspot(null);
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        className={
          isHotspot !== null
            ? "popup-container-rod"
            : "popup-container-rod-close"
        }
      >
        <div
          className="popup-container-rod-close-button media-icon"
          onClick={() => iconClick()}
        >
          +
        </div>
        <div className="popup-container-rod-name">
          {isHotspot !== null && isHotspot.name}
        </div>
        <div className="popup-container-rod-category">
          {isHotspot !== null && isHotspot.category}
        </div>
        <div className="popup-container-rod-address">
          Address:
          <br />
          {isHotspot !== null && isHotspot.address}
        </div>
        <div className="popup-container-rod-info">
          {isHotspot !== null && isHotspot.info}
        </div>

        {isHotspot !== null && (
          <>
            {isHotspot.social !== "" && (
              <div className="popup-container-rod-social">
                <a href={isHotspot.social} target="_blank">
                  LINK
                </a>
              </div>
            )}
          </>
        )}
        <div className="popup-container-rod-extra">
          {isHotspot !== null && isHotspot.extra}
        </div>

        <div className="popup-container-rod-number">
          {isHotspot !== null && isHotspot.number}
        </div>
      </div>

      <Map
        ref={mapRef}
        center={[0, 0]}
        zoom={3}
        maxZoom={19}
        minZoom={11}
        bounceAtZoomLimits={true}
        maxBoundsViscosity={0.95}
        maxBounds={bounds}
        onclick={() => setisHotspot(null)}
      >
        <TileLayer
          noWrap={false}
          url="https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png"
        />

        <RodFooter />
      </Map>
    </div>
  );
};

export default Mapa;
